<div [style.left]="dropPositionX" [style.top]="dropPositionY" [class.selected]="isSelected" class="custom-wrapper" (click)="selectComponent()">
  {{data.Name}}
  <ng-icon *ngIf="isSelected" name="heroCog8Tooth" class="settings-icon" (click)="toggleSettings($event)">
  </ng-icon>
  <ng-icon *ngIf="isSelected" name="heroTrash" class="remove-icon" (click)="removeComponent($event)">
  </ng-icon>

  <div class="properties-panel" *ngIf="showProperties">
    <div class="field-group">
      <mat-form-field appearance="outline">
        <mat-label>Assigned to</mat-label>
        <mat-select [(ngModel)]="selectedSignatory" (selectionChange)="onSignatorySelect($event)" disabled>
          <mat-option *ngFor="let signatory of signatories" [value]="signatory.EmailId">
            {{signatory.Name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="field-group">
      <mat-form-field appearance="outline">
        <mat-label>Select Page</mat-label>
        <mat-select [(ngModel)]="selectedPageOption" (selectionChange)="onPageChange()">
          <mat-option *ngFor="let option of pageOptions" [value]="option">
            {{option}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="field-group" *ngIf="selectedPageOption === 'SPECIFY'">
      <mat-form-field appearance="outline">
        <mat-label>Page Numbers</mat-label>
        <input matInput [(ngModel)]="pageNumbers" placeholder="eg: 1,2,3">
      </mat-form-field>
    </div>

    <div class="field-group">
      <button mat-raised-button color="primary" class="outlined-btn" (click)="showProperties = false">Close</button>
      <button mat-raised-button color="accent" class="ml-3" (click)="onSubmit()">Apply</button>
    </div>
  </div>
</div>